import { t } from '../theme';
import type { ItemWithExpiry } from '../api';
import { useStore } from '../store';

/**
 * How many of one batch are in the fridge.
 *
 * Per batch, like the date beside it: a group's total is a sum of several
 * rows, so there is no single number to edit.
 *
 * The floor is 1. Emptying a batch is what "Verbraucht" is for, and a stepper
 * that silently deletes the thing you are looking at when you tap once too
 * often is a worse control than one that stops.
 */
export function QtyStepper({ batch, compact = false }: { batch: ItemWithExpiry; compact?: boolean }) {
  const setQty = useStore((s) => s.setQty);
  const size = compact ? 34 : 42;

  const step = (delta: number) => {
    const next = Math.max(1, Math.min(999, batch.qty + delta));
    if (next !== batch.qty) void setQty(batch.id, next);
  };

  const button = (label: string, delta: number, disabled = false) => (
    <div
      className={disabled ? undefined : 'press'}
      onClick={() => !disabled && step(delta)}
      style={{
        width: size,
        height: size,
        flex: 'none',
        borderRadius: compact ? 10 : 12,
        background: disabled ? 'transparent' : t.control,
        border: disabled ? t.hairline : 'none',
        color: disabled ? 'oklch(0.45 0.012 60)' : t.ink,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: compact ? 18 : 22,
        fontWeight: 500,
      }}
    >
      {label}
    </div>
  );

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: compact ? 6 : 8, flex: 'none' }}>
      {button('−', -1, batch.qty <= 1)}
      <div
        style={{
          minWidth: compact ? 34 : 46,
          textAlign: 'center',
          fontSize: compact ? 17 : 21,
          fontWeight: 600,
        }}
      >
        {batch.qty}×
      </div>
      {button('+', 1)}
    </div>
  );
}
